import { ArrowRight, Sparkles } from "lucide-react";
import { useMemo } from "react";

const FinalCTA = ({ onJoinClick }) => {
  // Generate floating particles
  const particles = useMemo(() => {
    return Array.from({ length: 15 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      delay: `${Math.random() * 3}s`,
      duration: `${3 + Math.random() * 2}s`
    }));
  }, []);

  return (
    <section id="final-cta" data-testid="final-cta-section" className="section-primary cta-section">
      <div className="section-glow center" style={{ width: '800px', height: '800px', background: 'rgba(212, 168, 83, 0.1)' }}></div>
      
      {/* Floating Particles */}
      <div className="hero-particles">
        {particles.map(p => (
          <div 
            key={p.id}
            className="particle"
            style={{
              left: p.left,
              top: p.top,
              animationDelay: p.delay,
              animationDuration: p.duration,
              background: 'rgba(212, 168, 83, 0.3)'
            }}
          />
        ))}
      </div>
      
      <div className="cta-content">
        <div className="cta-badge">
          <Sparkles size={16} />
          <span>Join the Movement</span>
        </div>
        
        <h2 className="cta-title">
          <span className="white">Education First.</span>{" "}
          <span className="gold">Structure Always.</span>
        </h2>
        
        <div className="section-divider"></div>
        
        <div className="cta-group" style={{ opacity: 1 }}>
          <button 
            data-testid="final-join-btn" 
            className="btn-primary"
            onClick={onJoinClick}
          >
            <span>Join the FLEXX Academy Community</span>
            <ArrowRight className="btn-icon" size={16} />
          </button>
          <a href="#collaboration" data-testid="final-explore-btn" className="btn-secondary">
            <span>Explore Collaboration Opportunities</span>
            <ArrowRight className="btn-icon" size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
